export default {
    capitalizeFirst(text) {
        if(!text){
            return text;
        }
        return text.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
            return a.toUpperCase();
        });
    },
};
